import React from "react";
import { Building2, Building, Dumbbell, Baby, Store, Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Office Cleaning",
  description: "Maintain a pristine professional environment with our comprehensive office cleaning solutions, tailored for productivity and hygiene.",
  icon: Building2
}, {
  title: "Strata Cleaning",
  description: "Reliable maintenance for residential and commercial strata complexes, ensuring common areas remain spotless and welcoming.",
  icon: Building
}, {
  title: "Gym Cleaning",
  description: "Specialized sanitation for fitness centers, focusing on high-touch surfaces, equipment hygiene, and odor control.",
  icon: Dumbbell
}, {
  title: "Childcare & Daycare",
  description: "Safe, non-toxic cleaning protocols designed for childcare facilities to protect the health of children and staff.",
  icon: Baby
}, {
  title: "Pressure Washing",
  description: "Comprehensive pressure washing for carports, houses, driveways and more..",
  icon: Store
}, {
  title: "End of Lease",
  description: "Deep cleaning services that guarantee bond retrieval and prepare commercial spaces for the next occupants.",
  icon: Sparkles
}];
export default function CleaningExcellenceSuite() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="cleaning-excellence-suite" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
            Cleaning Excellence Suite
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Our gold standard services tailored for every commercial need.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {services.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full bg-card border border-primary/30 md:border-transparent hover:border-primary/60 transition-all duration-500 group hover:-translate-y-2 hover:rotate-1 hover:shadow-[0_10px_40px_-10px_rgba(0,0,0,0.5)] relative overflow-hidden">
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                
                <CardContent className="p-8 flex flex-col h-full relative z-10">
                  <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-secondary/50 group-hover:bg-primary/10 transition-colors duration-300">
                    <service.icon className="size-8 text-primary transition-all duration-500 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_var(--color-primary)]" strokeWidth={1.5} />
                  </div>
                  
                  <h3 className="text-2xl font-semibold text-white mb-3 group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </h3>
                  
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}